import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "react-i18next";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Keyboard, Navigation, Pagination } from "swiper/modules";

import PortfolioStyles from "./Portfolio.module.scss";
import socketChat from "../../assets/images/portfolio/socketChat-efrei-m2.png";
import socketChatBW from "../../assets/images/portfolio/socketChat-efrei-m2-B&W.png";
import dealChat from "../../assets/images/portfolio/dealChat-efrei-m1.png";
import dealChatBW from "../../assets/images/portfolio/dealChat-efrei-m1-B&W.png";
import mangaSekai from "../../assets/images/portfolio/mangaSekai-efrei-m1.png";
import mangaSekaiBW from "../../assets/images/portfolio/mangaSekai-efrei-m1-B&W.png";
import mavoie from "../../assets/images/portfolio/mavoie.png";
import mavoieBW from "../../assets/images/portfolio/mavoie-B&W.png";
import myEfrei from "../../assets/images/portfolio/myEfrei-efrei-b3.png";
import myEfreiBW from "../../assets/images/portfolio/myEfrei-efrei-b3-B&W.png";
import rpg from "../../assets/images/portfolio/rpg-efrei-b3.png";
import rpgBW from "../../assets/images/portfolio/rpg-efrei-b3-B&W.png";
import cosmicHarvesters from "../../assets/images/portfolio/cosmic-harvesters.png";
import cosmicHarvestersBW from "../../assets/images/portfolio/cosmic-harvesters-B&W.png";
import artificielEducation from "../../assets/images/portfolio/artificiel-education.png";
import artificielEducationBW from "../../assets/images/portfolio/artificiel-education-B&W.png";
import lolTogether from "../../assets/images/portfolio/lol-together.png";
import lolTogetherBW from "../../assets/images/portfolio/lol-together-B&W.png";
import sentimentalAnalyzer from "../../assets/images/portfolio/sentimental-analyzer.png";
import sentimentalAnalyzerBW from "../../assets/images/portfolio/sentimental-analyzer-B&W.png";
import urlShortener from "../../assets/images/portfolio/url-shortener.png";
import urlShortenerBW from "../../assets/images/portfolio/url-shortener-B&W.png";

const Portfolio = () => {
  const { t } = useTranslation();

  const projectImages = {
    "Liv.IA": [mavoie, mavoieBW],
    SocketChat: [socketChat, socketChatBW],
    DealChat: [dealChat, dealChatBW],
    "Manga Sekai": [mangaSekai, mangaSekaiBW],
    myEfrei: [myEfrei, myEfreiBW],
    JavaRPG: [rpg, rpgBW],
    "Cosmic Harvesters": [cosmicHarvesters, cosmicHarvestersBW],
    "Artificial Education": [artificielEducation, artificielEducationBW],
    "LoL-Together": [lolTogether, lolTogetherBW],
    "Sentimental Analyzer": [sentimentalAnalyzer, sentimentalAnalyzerBW],
    "URL-Shortener": [urlShortener, urlShortenerBW],
  };

  const projectLinks = {
    "Liv.IA": {
      // link: "https://livia.mavoie.org/",
      // link2: undefined,
      website: "https://livia.mavoie.org/",
      tags: [
        "Azure OpenAI",
        "Capacitor",
        "Figma",
        "Firebase",
        "Ionic",
        "I18n",
        "JavaScript",
        "Jest",
        "React",
        "Material-UI",
        "Nest",
        "Sass",
        "Storybook",
        "Swagger",
        "Tanstack Query",
        "TypeScript",
      ],
    },
    SocketChat: {
      link: "https://github.com/JongCHONG/EfreiM2DevManager/tree/aaddf2538d7f4c6ae81f00501774feb485641c5e/Progammation%20%C3%A9v%C3%A8nementielle%20et%20temps%20r%C3%A9el/nodejs%20socket%20mongodb",
      // link2: undefined,
      // website: undefined,
      tags: ["React", "Node", "JavaScript", "Socket.IO", "MongoDB"],
    },
    DealChat: {
      link: "https://github.com/JongCHONG/EfreiM1ProjetWebFront/tree/jong-front",
      link2: "https://github.com/JongCHONG/EfreiM1ProjetWebBack/tree/jong-back",
      // website: "https://dealchat.example.com/",
      tags: [
        "React",
        "Prisma",
        "WebSocket",
        "NestJS",
        "Docker",
        "RabbitMQ",
        "GraphQL",
      ],
    },
    "Manga Sekai": {
      link: "https://github.com/JongCHONG/EfreiM1DevManager/tree/main/GraphQL/server",
      link2:
        "https://github.com/JongCHONG/EfreiM1DevManager/tree/main/GraphQL/tp-manga-sekai",
      // website: undefined,
      tags: ["Vite", "GraphQL", "MongoDB", "Node", "TypeScript"],
    },
    myEfrei: {
      link: "https://github.com/JongCHONG/EfreiB3DevData/tree/main/React/myEfreiByJong",
      link2:
        "https://github.com/JongCHONG/EfreiB3DevData/tree/main/Webservices/TP1v2%20-%20myEfrei",
      // website: undefined,
      tags: ["Express", "Mongoose", "MongoDB", "React", "Sass"],
    },
    JavaRPG: {
      link: "https://github.com/JongCHONG/EfreiB3DevData/tree/main/POO%20Java/Cour1Rpg",
      // link2: undefined,
      // website: undefined,
      tags: ["Java"],
    },
    "Cosmic Harvesters": {
      link: "https://github.com/JongCHONG/Cosmic-Harvesters",
      // link2: undefined,
      // website: "https://cosmic-harvesters.com/",
      tags: ["Rust", "Github"],
    },
    "Artificial Education": {
      link: "https://github.com/JongCHONG/Artificial-Education",
      // link2: undefined,
      // website: undefined,
      tags: ["Python", "SQLite", "Llama3", "Gemma2", "MixTral"],
    },
    "LoL-Together": {
      link: "https://github.com/JongCHONG/LoL-Together",
      // link2: undefined,
      website: "https://lol-together.netlify.app/",
      tags: [
        "MERN",
        "JavaScript",
        "Node.js",
        "Express",
        "MongoDB",
        "React",
        "Formik",
        "Yup",
        "framer-motion",
      ],
    },
    "Sentimental Analyzer": {
      link: "https://github.com/JongCHONG/Sentimental-Analyzer",
      // link2: undefined,
      // website: undefined,
      tags: ["Python", "Flask", "NLP", "Machine Learning", "MySQL", "CRONjob"],
    },
    "URL-Shortener": {
      link: "https://github.com/JongCHONG/URL-Shortener",
      // link2: undefined,
      // website: undefined,
      tags: ["Go"],
    },
  };

  const projects = t("portfolio.projects", { returnObjects: true }).map(
    (project, index) => ({
      ...project,
      img: projectImages[project.title],
      link: projectLinks[project.title]?.link,
      link2: projectLinks[project.title]?.link2,
      website: projectLinks[project.title]?.website,
      tags: projectLinks[project.title]?.tags || [],
    })
  );

  const [showSwiper, setShowSwiper] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleCardClick = (index) => {
    setSelectedIndex(index);
    setShowSwiper(true);
  };

  const handleClose = () => {
    setShowSwiper(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  useEffect(() => {
    if (showSwiper) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showSwiper]);  

  return (
    <div className={PortfolioStyles.container}>
      <div className={PortfolioStyles.title}>{t("portfolio.title")}</div>
      <div className={PortfolioStyles.projects}>
        {projects.map((project, index) => (
          <div
            key={index}
            className={PortfolioStyles.project}
            onClick={() => handleCardClick(index)}
          >
            <img
              src={isMobile ? project.img[0] : project.img[1]}
              alt={`${project.title} logo`}
              className={PortfolioStyles.image}
              onMouseEnter={(e) => {
                e.target.src = project.img[0];
              }}
              onMouseLeave={(e) => {
                e.target.src = project.img[1];
              }}
            />
            <div className={PortfolioStyles.projectTitle}>{project.title}</div>
          </div>
        ))}
      </div>

      {showSwiper && (
        <div
          className={PortfolioStyles.swiperOverlay}
          onClick={handleOverlayClick}
        >
          <button className={PortfolioStyles.closeButton} onClick={handleClose}>
            ×
          </button>
          <Swiper
            grabCursor={true}
            pagination={true}
            modules={[Keyboard, Navigation, Pagination]}
            className={PortfolioStyles.swiper}
            keyboard={{ enabled: true }}
            initialSlide={selectedIndex}
            navigation
            loop
          >
            {projects.map((project, index) => (
              <SwiperSlide key={index} className={PortfolioStyles.swiperSlide}>
                <div className={PortfolioStyles.cardHeader}>
                  <img
                    src={project.img[0]}
                    alt={`${project.title}`}
                    className={PortfolioStyles.image}
                    width="30%"
                  />
                  <div className={PortfolioStyles.cardInfo}>
                    <div className={PortfolioStyles.cardTitle}>
                      {project.title}
                    </div>
                    {project.link && (
                      <div className={PortfolioStyles.cardLink}>
                        <a
                          href={project.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("portfolio.links.githubLink1")}
                        </a>
                      </div>
                    )}
                    {project.link2 && (
                      <div className={PortfolioStyles.cardLink}>
                        <a
                          href={project.link2}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("portfolio.links.githubLink2")}
                        </a>
                      </div>
                    )}
                    {project.website && (
                      <div className={PortfolioStyles.cardLink}>
                        <a
                          href={project.website}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("portfolio.links.website")}
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                <div className={PortfolioStyles.cardDesc}>
                  {project.description}
                </div>
                <br />
                {project.description2 && (
                  <div className={PortfolioStyles.cardDesc}>
                    {project.description2}
                  </div>
                )}
                <br />
                <div className={PortfolioStyles.tags}>
                  {project.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className={PortfolioStyles.tag}>
                      {tag}
                    </span>
                  ))}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
};

export default Portfolio;
